import * as React from 'react'

import { EditorContextMenuShell } from '../editor-context-menu-shell'
import { MenuActionRows, type MenuActions } from '../menu-action-rows'
import { PHOTO_MENU_ROWS } from './constants/photo-menu-rows'
import type { PhotoMenuActionId } from './types/photo-menu-action-id'

export interface PhotoContextMenuProps {
  open: boolean
  position: { x: number; y: number }
  onOpenChange: (open: boolean) => void
  viewportBoundsRef?: React.RefObject<HTMLElement | null>
  /** Every row's behavior and state, keyed by row id — the photo rows plus the shared object rows
   *  (arrange, group, clipboard, lock/freeze). See `PHOTO_MENU_ROWS`. */
  actions: MenuActions<PhotoMenuActionId>
}

export function PhotoContextMenu({
  open,
  position,
  onOpenChange,
  viewportBoundsRef,
  actions,
}: PhotoContextMenuProps) {
  const handleItemClick = (run?: () => void) => {
    run?.()
    onOpenChange(false)
  }

  return (
    <EditorContextMenuShell
      open={open}
      position={position}
      onOpenChange={onOpenChange}
      viewportBoundsRef={viewportBoundsRef}
    >
      <MenuActionRows rows={PHOTO_MENU_ROWS} actions={actions} onItemClick={handleItemClick} />
    </EditorContextMenuShell>
  )
}

export default PhotoContextMenu
